import { Colors, FInter, FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";
import { Position } from "../ChaptersNavigation";
import { LayoutConst } from "core";
import { RectangularButtonHollow } from "shared/components/buttons";

export const FloatingPagerWrapper = styled(FlexBox)<{ position: Position }>`
    z-index: 1000;
    color: ${Colors.galBlack61};
    //background: ${(p) => p.theme.projectEdit.imgContainerBg};
    flex-direction: row;
    align-items: center;
    justify-content: center;
    user-select: none;
    gap: 22px;
    padding: 4px 0px;
    //box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    //border-radius: 60px;
    //position: fixed;
    //opacity: 0.98;
    //bottom: 56px;
    //left: 50%;
    //-webkit-transform: translateX(-50%);
    //transform: translateX(-50%);
    @media (max-width: ${LayoutConst.screen.l_12}px){
        gap: 16px;
    }

    ${RectangularButtonHollow} {
        color: ${({ theme }) => theme.projectEdit.book.chaptersButtons.color};
        font-weight: 600;

        svg path {
            fill: ${({ theme }) => theme.projectEdit.book.chaptersButtons.color};
        }
    }

    ${({ position }) => [Position.bottom]?.includes(position) && css`
        padding-top: 48px;
        justify-content: flex-start;
        gap: 4px;
        max-width: ${LayoutConst.projectContainer.l}px;
        ${RectangularButtonHollow} {
            margin-left: auto;
            height: 38px;
            min-height: 38px;
            max-height: 38px;
        }

        svg {
            margin-left: 12px;
            margin-top: 2px;
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            max-width: ${LayoutConst.projectContainer.m}px;
            margin: 0 auto;
            width: 100%;

            ${RectangularButtonHollow} {
                height: 36px;
                min-height: 36px;
                max-height: 36px;
            }
        }

        @media (max-width: ${LayoutConst.screen.s -1}px) {
            flex-wrap: wrap;
            gap: 8px;
            ${RectangularButtonHollow} {
                margin: 16px auto auto auto;
                width: 100%;
            }
        }
    `};

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const FloatingPagerItem = styled(FInter.SmallTextMagic)<{ position: Position}>`
    //width: 22px;
    color: ${Colors.galBlack47};
    height: 28px;
    font-size: 13px;
    line-height: 16px;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;

    ${({ position }) => [Position.bottom]?.includes(position) && css`
        height: 36px;
        width: 39px;
    `};

    &:hover, &.active {
        color: ${({theme}) =>  theme.navigationBar.textActiveColor || Colors.galBlack100};
        //font-weight: 500;
        //background: ${({theme}) => theme.navigationBar.btns.filled.background.main};
        ${({ position }) => [Position.bottom]?.includes(position) && css`
            background-color: #f2f2f2;
        `};
    }

    &.disabled {
        cursor: not-allowed;
        color: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};
        //background: ${(p) => p.theme.projectEdit.imgContainerBg};
    }
`;

export const Title = styled.div`
    font-size: 17px;
    line-height: 22px;
    color: #909090;
    margin-right: 16px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;import { Colors, FInter, FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";
import { Position } from "../ChaptersNavigation";
import { LayoutConst } from "core";
import { RectangularButtonHollow } from "shared/components/buttons";

export const FloatingPagerWrapper = styled(FlexBox)<{ position: Position }>`
    z-index: 1000;
    color: ${Colors.galBlack61};
    //background: ${(p) => p.theme.projectEdit.imgContainerBg};
    flex-direction: row;
    align-items: center;
    justify-content: center;
    user-select: none;
    gap: 22px;
    padding: 4px 0px;
    //box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.12);
    //border-radius: 60px;
    //position: fixed;
    //opacity: 0.98;
    //bottom: 56px;
    //left: 50%;
    //-webkit-transform: translateX(-50%);
    //transform: translateX(-50%);
    @media (max-width: ${LayoutConst.screen.l_12}px){
        gap: 16px;
    }

    ${RectangularButtonHollow} {
        color: ${({ theme }) => theme.projectEdit.book.chaptersButtons.color};
        font-weight: 600;

        svg path {
            fill: ${({ theme }) => theme.projectEdit.book.chaptersButtons.color};
        }
    }

    ${({ position }) => [Position.bottom]?.includes(position) && css`
        padding-top: 48px;
        justify-content: flex-start;
        gap: 4px;
        max-width: ${LayoutConst.projectContainer.l}px;
        ${RectangularButtonHollow} {
            margin-left: auto;
            height: 38px;
            min-height: 38px;
            max-height: 38px;
        }

        svg {
            margin-left: 12px;
            margin-top: 2px;
        }

        @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
            max-width: ${LayoutConst.projectContainer.m}px;
            margin: 0 auto;
            width: 100%;

            ${RectangularButtonHollow} {
                height: 36px;
                min-height: 36px;
                max-height: 36px;
            }
        }

        @media (max-width: ${LayoutConst.screen.s -1}px) {
            flex-wrap: wrap;
            gap: 8px;
            ${RectangularButtonHollow} {
                margin: 16px auto auto auto;
                width: 100%;
            }
        }
    `};

    @media (max-width: ${LayoutConst.screen.s -1}px) {
        padding-left: 10px;
        padding-right: 10px;
    }
`;

export const FloatingPagerItem = styled(FInter.SmallTextMagic)<{ position: Position}>`
    //width: 22px;
    color: ${Colors.galBlack47};
    height: 28px;
    font-size: 13px;
    line-height: 16px;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    white-space: nowrap;

    ${({ position }) => [Position.bottom]?.includes(position) && css`
        height: 36px;
        width: 39px;
    `};

    &:hover, &.active {
        color: ${({theme}) =>  theme.navigationBar.textActiveColor || Colors.galBlack100};
        //font-weight: 500;
        //background: ${({theme}) => theme.navigationBar.btns.filled.background.main};
        ${({ position }) => [Position.bottom]?.includes(position) && css`
            background-color: #f2f2f2;
        `};
    }

    &.disabled {
        cursor: not-allowed;
        color: ${({theme}) => theme.navigationBar.btns.filled.text.disabled};
        //background: ${(p) => p.theme.projectEdit.imgContainerBg};
    }
`;

export const Title = styled.div`
    font-size: 17px;
    line-height: 22px;
    color: #909090;
    margin-right: 16px;
    font-weight: 600;

    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
        font-size: 15px;
        line-height: 20px;
    }
`;